__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "service-providers";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@auth0/auth0-react", "2.1.0", () => (Promise.all([__webpack_require__.e(988), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(21988))))));
			register("@reduxjs/toolkit", "1.9.5", () => (Promise.all([__webpack_require__.e(258), __webpack_require__.e(898), __webpack_require__.e(2)]).then(() => (() => (__webpack_require__(60258))))));
			register("graphql-request", "6.1.0", () => (Promise.all([__webpack_require__.e(554), __webpack_require__.e(500)]).then(() => (() => (__webpack_require__(81554))))));
			register("graphql", "14.0.0", () => (__webpack_require__.e(517).then(() => (() => (__webpack_require__(46517))))));
			register("moment", "2.29.4", () => (Promise.all([__webpack_require__.e(595), __webpack_require__.e(358)]).then(() => (() => (__webpack_require__(95093))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(556).then(() => (() => (__webpack_require__(5556))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-redux", "8.0.5", () => (Promise.all([__webpack_require__.e(733), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(112)]).then(() => (() => (__webpack_require__(69733))))));
			register("react-router-dom", "6.11.2", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(92648))))));
			register("react", "18.2.0", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
			register("redux-persist", "6.0.0", () => (Promise.all([__webpack_require__.e(385), __webpack_require__.e(898)]).then(() => (() => (__webpack_require__(41385))))));
			register("redux-thunk", "2.4.2", () => (__webpack_require__.e(265).then(() => (() => (__webpack_require__(1265))))));
			register("redux", "4.2.1", () => (__webpack_require__.e(960).then(() => (() => (__webpack_require__(82960))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};